import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BasicTable } from '../../../commons/customTables/BasicTable';
import { CustomTable } from '../../../../models/CustomTable';
import DateVO from '../../../../core/valueObjects/DateVO';
import { useDateLocalization } from '../../../../hooks/useDateLocalization';
import { OnlineTime, SessionItem } from '../../../../models/Sessions';
import { SessionRowProps } from '../Sessions';

interface OnlineSessionProps {
  formatOnlineTime: (time: OnlineTime) => string;
  createRow: (props: SessionRowProps) => {
    bodyCells: string[];
    isCollapsibleButton: boolean;
    id: string | number;
    history: JSX.Element;
  };
  onlineSession: SessionItem | undefined;
}

export const OnlineSession: FC<OnlineSessionProps> = ({ formatOnlineTime, createRow, onlineSession }) => {
  const { t } = useTranslation();
  const { formatDate } = useDateLocalization();

  const sessionTable: CustomTable = {
    tableHead: [`${t('serviceManagement.start')}`, `${t('serviceManagement.onlineTime')}`],
    tableBodyCells:
      (onlineSession && [
        createRow({
          id: onlineSession.id,
          start: formatDate(DateVO.create(onlineSession.InDate || '').get(), {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
            locale: 'uk',
          }),
          onlineTime: formatOnlineTime(onlineSession.OnlineTime),
          ipv4: `${onlineSession && onlineSession.Outer_IP.ipv4}`,
          ipv4Sent: `${onlineSession && onlineSession.Sent.ipv4}`,
          ipv4Received: `${onlineSession && onlineSession.Received.ipv4}`,
          ipv6: `${onlineSession && onlineSession.Outer_IP.ipv6}`,
          ipv6Sent: `${onlineSession && onlineSession.Sent.ipv6}`,
          ipv6Received: `${onlineSession && onlineSession.Received.ipv6}`,
        }),
      ]) ||
      undefined,
  };

  return onlineSession ? (
    <BasicTable tableHead={sessionTable.tableHead} tableBodyCells={sessionTable.tableBodyCells} />
  ) : (
    <p style={{ paddingTop: '3px' }} className="label">
      {t('serviceManagement.youHaveNoActiveSessions')}
    </p>
  );
};
